import {
  LpBasicInfo,
  OpravnenieEnum,
  Organizacia as OrganizaciaDto,
  Pouzivatel as PouzivatelDto,
  UserApi,
  UserDetail,
  UserDetailWithLp,
} from 'pripomienky-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import { ClientResponse } from '../model/ClientResponse';
import apiConfiguration from './configuration/apiConfiguration';
import UserRole from '../model/currentuser/UserRole';
import CurrentUserWithLp from '../model/currentuser/CurrentUserWithLp';
import CurrentUserDetail from '../model/currentuser/CurrentUserDetail';
import {
  LegislationProcessInfo,
  Organizacia,
  Pouzivatel,
} from '../model/currentuser/LegislationProcessInfo';
import { generatedToStadiumMaterialuEnum } from '../model/currentuser/StadiumMaterialuEnum';
import { pripomienkyPrefixPath } from './configuration/apiConfigurationConstants';

const client = new UserApi(apiConfiguration(pripomienkyPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const fetchCurrentPouzivatelWithLp = async (
  type: string,
  year: number,
  index: number,
  options?: AxiosRequestConfig,
)
  : Promise<ClientResponse<CurrentUserWithLp>> => {
  const { data, status } = await client.getCurrentUserWithLp(type, year, index, options);

  return {
    data: map(data),
    responseCode: status,
  };
};

const map = (data: UserDetailWithLp): CurrentUserWithLp => ({
  user: data.user == null ? null : mapUserData(data.user),
  legislationProcess: data.legislationProcess ? mapLegProcess(data.legislationProcess) : null,
});

const mapUserData = (data: UserDetail): CurrentUserDetail => ({
  ...data,
  opravnenia: mapOpravnenieEnumList(data.opravnenia),
});

const mapOrganizacia = (organizacia: OrganizaciaDto): Organizacia => ({
  uuid: organizacia.uuid,
  nazov: organizacia.nazov,
  skratenyNazov: organizacia.skratenyNazov,
  email: organizacia.email,
  ldapUuid: organizacia.ldapUuid,
});

const mapPouzivatel = (pouzivatel: PouzivatelDto): Pouzivatel => ({
  uuid: pouzivatel.uuid,
  nazov: pouzivatel.nazov,
  skratenyNazov: pouzivatel.skratenyNazov,
  email: pouzivatel.email,
});

const mapLegProcess = (data: LpBasicInfo): LegislationProcessInfo => ({
  ...data,
  stadiumProcesu: generatedToStadiumMaterialuEnum(data.stadiumProcesu),
  datumKoncaMpk: data.datumKoncaMpk == null ? null : new Date(data.datumKoncaMpk),
  exists: data.stadiumProcesu !== null,
  legMaterialUuid: data.legMaterialUuid,
  legMaterialCislo: data.legMaterialCislo,
  typCode: data.typCode,
  aktualnyPredkladatel: data.aktualnyPredkladatel == null ? null : mapPouzivatel(data.aktualnyPredkladatel),
  aktualnaInstitucia: data.aktualnaInstitucia == null ? null : mapOrganizacia(data.aktualnaInstitucia),
  gestor: data.gestor == null ? null : mapOrganizacia(data.gestor),
  spolugestorList: (data.spolugestorList == null || data.spolugestorList.length === 0)
    ? null
    : data.spolugestorList.map(mapOrganizacia),
});

const mapOpravnenieEnumList = (opravnenieList: OpravnenieEnum[]): UserRole[] => (
  !opravnenieList ? [] : opravnenieList.map(opravnenie => UserRole[opravnenie])
);
